import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import ru from 'vuetify/src/locale/ru.ts'

Vue.use(Vuetify)

const opts = {
	icons: {
		iconfont: 'mdi',
	},
	// Интерфейс исторически построен на палитре `blue` (тулбары списков, вкладки),
	// а дефолтный `primary` у Vuetify — более тёмный #1976D2. Из-за этого экраны
	// с `color="primary"` отличались оттенком. Приравниваем их.
	theme: {
		// Какая тема включится, решает shared/lib/theme.js — он же ставит
		// data-theme на <html>. Здесь важно лишь, чтобы обе были описаны:
		// Vuetify красит собственные компоненты своими средствами.
		themes: {
			light: {
				// Акцент интерфейса — холодный зелёный с пультов управления.
				primary: '#1E8A6E',
				// Состояния груза и системы. Ими окрашиваются строки, точки
				// статусов и индикаторы связи — больше цвету места нет.
				'sts-wait': '#78859B',
				'sts-transit': '#C98A14',
				'sts-placed': '#1E8A6E',
				'sts-out': '#3B72B0',
				'sts-alert': '#BC3B31',
				'sts-ok': '#1E8A6E',
			},
			// Те же роли, поднятые по светлоте: на тёмной подложке исходные
			// оттенки садятся и перестают отличаться друг от друга.
			dark: {
				primary: '#2FBF9B',
				'sts-wait': '#9AA8BD',
				'sts-transit': '#F0B23C',
				'sts-placed': '#3ECF9E',
				'sts-out': '#5AA6F0',
				'sts-alert': '#F2685C',
				'sts-ok': '#3ECF9E',
			},
		},
	},
	lang: {
		locales: { ru },
		current: 'ru',
	}
}

export default new Vuetify(opts)
